<template>
  <div>
    <GoodsFabric
      class="mb-3"
      :disabled="disabled"
      :techGoodsSpecCode="techGoodsSpecCode"
      :tableHeight="tableHeight"
    />
    <GoodsMaterial
      class="mb-3"
      :disabled="disabled"
      :productLine="productLine"
      :techGoodsSpecCode="techGoodsSpecCode"
      :tableHeight="tableHeight"
    />
    <GoodsCutting
      class="mb-3"
      :disabled="disabled"
      :techGoodsSpecCode="techGoodsSpecCode"
      :tableHeight="tableHeight"
    />
  </div>
</template>

<script>
import GoodsMaterial from '../goods-material/table'
import GoodsFabric from '../goods-fabric/table'
import GoodsCutting from '../goods-cutting/table'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  components: {
    GoodsMaterial,
    GoodsFabric,
    GoodsCutting,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    techCode: {
      type: String,
      default: '',
    },
    productLine: {
      type: String,
      default: '',
    },
    techGoodsSpecCode: {
      type: String,
      default: '',
    },
  },
  methods: {
    getHeight() {
      this.tableHeight = (window.innerHeight - 131) / 4 - 50
    },
  },
}
</script>
